import {ImportParseCompleteBehavior} from '@ispm/shared/bpmn-io/behavior/import-parse-complete-behavior';
import {PathwayGraphicsFactory} from '@ispm/shared/bpmn-io/pathway-graphics-factory';
import {PathwayElementRegistry} from '@ispm/shared/bpmn-io/pathway-element-registry';
import {SubprocessChildrenAddBehavior} from '@ispm/shared/bpmn-io/subprocess-children-add-behavior';
import {PathwayOverlays} from "@ispm/shared/bpmn-io/pathway-overlays";
import {CustomConnectionPreview} from "@ispm/shared/bpmn-io/custom-conncetion-preview";

export const LazyLoadingExtensionModule = {
    __init__: ['importParseCompleteBehavior', 'subprocessChildrenAddBehavior'],

    importParseCompleteBehavior: ['type', ImportParseCompleteBehavior],
    graphicsFactory: ['type', PathwayGraphicsFactory],
    elementRegistry: ['type', PathwayElementRegistry],
    overlays: ['type', PathwayOverlays],
    subprocessChildrenAddBehavior: ['type', SubprocessChildrenAddBehavior],
    connectionPreview: ['type',CustomConnectionPreview]
};
